import React from 'react';
import './EventDetails.css';

export default function EventDetails({ eventID, toggleModal }) {
  return (
    <div 
      className="modal"
      onClick={() => toggleModal()}
    >
      <iframe 
        scrolling="no" 
        title={'Event' + eventID} 
        src={`${process.env.REACT_APP_DOMAIN}/Events/EventUV/?EventID=${eventID}`}
      >
      </iframe>
      <button 
        type="button" 
        className="close"
        onClick={() => toggleModal()}
        >
        Close
      </button>
    </div>
  );
}